import {Module} from "vuex";
import {State} from "@/store";
import i18n from "@/i18n";
import {SnackbarMessage} from "@/models/SnackbarMessage";

export interface UI {
	locale: string;
	snackbarMessage: null | SnackbarMessage;
}

const ui: Module<UI, State> = {
	namespaced: true,
	state: {
		locale: 'de-CH',
		snackbarMessage: null as null | SnackbarMessage,
	},
	getters: {

	},
	mutations: {
		setLocale(state, locale: string): void {
			i18n.locale = locale;
			state.locale = locale;
		},
		showSnackbar(state, msg: SnackbarMessage) {
			state.snackbarMessage = msg;
		},
	},
};

export default ui;
